(function() { module.exports = window["eventespresso"]["storage"]; }());